module.exports = __webpack_public_path__ + "static/media/ship_yellow_flip.ec19312e.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_yellow_flip.png
// module id = 210
// module chunks = 0